'use es6';

const requiredKeys = ['authType', 'rootUrl', 'tracker', 'blockingRequests', 'getPurchaseMotions', 'defaultHubRoute']; //const exampleInterface = {
//  // Env-specific data
//  getLang: () => { ... },
//  getPurchaseMotions: () => { ... }
//  tracker: _PublicUsageTracker(),
//
//  // Env-specific business rules
//  allowTrials: false,
//  allowInlineChat: true,
//  allowMultiCurrency: true,
//  allowMon256Experiment: false,
//}
// Validates that a config has all the required keys

export default (config => {
  requiredKeys.forEach(key => {
    if (config[key] === undefined) {
      throw new Error(`config is missing ${key}`);
    }
  });
  return config;
});